/**
 * Les deux phrases du site des viewers que le paquet d'entree garde : `/rejoindre` et `/moi` sont livrees a part (`routes.tsx`), le
 * lien de l'accueil et l'attente du chargement ne peuvent pas attendre leur fichier. Ce sont les phrases de `rejoindre-texts.ts`,
 * recopiees ici pour ne pas tirer tout ce fichier dans l'entree : `entree-texts.test.ts` les compare.
 */

/** Le lien de l'accueil, et le titre de l'arrivee. */
export const LIEN_REJOINDRE = "Rejoindre le château";

/** Ce que la page dit pendant que son fichier arrive (« On ouvre la porte... », l'attente de la maquette). */
export const CHARGEMENT_DE_L_ENTREE = "On ouvre la porte...";

/** Le fichier de la page n'est pas arrive (le plus souvent l'app a ete mise a jour depuis l'ouverture de l'onglet). */
export const ENTREE_INDISPONIBLE = "La page n'a pas pu se charger. Réessaie dans un instant.";
export const ENTREE_RECHARGER = "Recharger la page";
